export default __webpack_public_path__ + "images/f64a4e8ea787775518320dfe7f8eeee9-reggae.webp";